import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./HomeSlider.css";

const HomeSlider = ({sliders}) => {

  return (
    <div className="home-slider-container">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        pagination={{ 
          clickable: true,
          dynamicBullets: true
        }}
        autoplay={{ 
          delay: 4000,
          disableOnInteraction: false
        }}
        loop
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }}
        className="responsive-swiper"
      >
        {sliders[0]?.value?.value && sliders[0]?.value?.value?.map((slider, index) => (
          <SwiperSlide key={index} className="slider-slide">
            <a href={slider.link || '#'} target="_blank" rel="noopener noreferrer" className="slider-link">
              <LazyLoadImage
                src={slider.photo_url}
                alt={`Slider image ${index + 1}`}
                className="slider-image"
                effect="blur"
                placeholderSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100%25' height='100%25' fill='%23f0f0f0'/%3E%3C/svg%3E"
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeSlider;